import * as Yup from 'yup'

export const schemaTag = (t: (key: string) => string) => ({
  slug: Yup.string().required(t('requiredMessage')),
  color: Yup.string().required(t('requiredMessage')),
})
